import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    FileText,
    Plus,
    Edit,
    Trash2,
    CheckCircle,
    X,
    TrendingUp,
    Settings,
    Info,
    Check,
    Minus,
} from 'lucide-react';
import Swal from 'sweetalert2';
import {
    fetchNoteDeFraisRequest,
    createNoteDeFraisRequest,
    updateNoteDeFraisRequest,
    deleteNoteDeFraisRequest,
} from '../../../../redux/actions/noteDeFraisActions';
import '../parametresStyles/ParamConges.css';

/* â”€â”€â”€ Toggle component â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
const Toggle = ({ checked, onChange, label, disabled }) => (
    <button
        type="button"
        className={`pcToggle ${checked ? "is-on" : ""}`}
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
        aria-pressed={checked}
    >
        <span className="pcToggle__thumb" />
        {label && <span className="pcToggle__label">{label}</span>}
    </button>
);

/* â”€â”€â”€ Tooltip component â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
const Tip = ({ text }) => (
    <span className="pcTip" data-tip={text}>
        <Info size={13} />
    </span>
);

const ParamNF = () => {
    const dispatch = useDispatch();
    const { notesDeFrais, loading, error } = useSelector((state) => state.noteDeFrais || {
        notesDeFrais: [],
        loading: false,
        error: null,
    });

    const [showModal, setShowModal] = useState(false);
    const [editItem, setEditItem] = useState(null);

    // State for the wizard form
    const [formData, setFormData] = useState({});
    const [stepErrors, setStepErrors] = useState({});

    const typeJustificatifOptions = [
        'FACTURE',
        'TICKET',
        'RECU',
        'ATTESTATION',
        'AUCUN',
    ];
    useEffect(() => {
        dispatch(fetchNoteDeFraisRequest());
    }, [dispatch]);

    /* form helpers */
    const set = useCallback((key, val) =>
        setFormData(p => ({ ...p, [key]: val })), []);

    const openModal = (note = null) => {
        setStepErrors({});
        if (note) {
            setEditItem(note);
            setFormData({
                category: note.category || '',
                libelle: note.libelle || '',
                code: note.code || '',
                devise: note.devise || 'MAD',
                montantMinimum: note.montantMinimum || '',
                montantMaximum: note.montantMaximum || '',
                typeJustificatif: note.typeJustificatif || '',
                obligatoire: note.obligatoire || false,
                centreCouts: note.centreCouts || '',
                actif: note.actif ?? true,
            });
        } else {
            setEditItem(null);
            setFormData({
                category: '',
                libelle: '',
                code: '',
                devise: 'MAD',
                montantMinimum: '',
                montantMaximum: '',
                typeJustificatif: '',
                obligatoire: false,
                centreCouts: '',
                actif: true,
            });
        }
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setEditItem(null);
        setFormData({});
        setStepErrors({});
    };

    const validateForm = () => {
        const errs = {};
        if (!formData.category?.trim()) errs.category = "Requis";
        if (!formData.libelle?.trim()) errs.libelle = "Requis";
        if (!formData.code?.trim()) errs.code = "Requis";

        if (formData.montantMinimum && formData.montantMaximum) {
            if (Number(formData.montantMinimum) > Number(formData.montantMaximum)) {
                errs.montantMaximum = "Le plafond doit être supérieur au minimum";
            }
        }

        if (formData.obligatoire && !formData.typeJustificatif) {
            errs.typeJustificatif = "Requis si justificatif obligatoire";
        }

        setStepErrors(errs);
        return Object.keys(errs).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        const payload = {
            ...formData,
            typeJustificatif: formData.typeJustificatif === "AUCUN" ? null : (formData.typeJustificatif || null),
            montantMinimum: formData.montantMinimum ? parseFloat(formData.montantMinimum) : null,
            montantMaximum: formData.montantMaximum ? parseFloat(formData.montantMaximum) : null,
        };

        if (editItem) {
            dispatch(updateNoteDeFraisRequest(editItem.id, payload));
        } else {
            dispatch(createNoteDeFraisRequest(payload));
        }
        closeModal();
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirmation',
            text: 'Voulez-vous vraiment supprimer cette note de frais ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#2f4595',
            confirmButtonText: 'Oui, supprimer',
            cancelButtonText: 'Annuler',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteNoteDeFraisRequest(id));
            }
        });
    };

    const toggleActif = (note) => {
        dispatch(
            updateNoteDeFraisRequest(note.id, {
                ...note,
                actif: !note.actif,
            })
        );
    };
    const renderModal = () => {
        if (!showModal) return null;
        const isEdit = !!editItem;

        return (
            <div className="pcModal">
                <div className="pcModal__panel" role="dialog" aria-modal="true" style={{ maxWidth: '600px' }}>
                    <div className="pcModal__header">
                        <div className="pcModal__title">
                            {isEdit ? 'Modifier la note de frais' : 'Ajouter une note de frais'}
                        </div>
                        <button className="pcIconBtn" onClick={closeModal} type="button" aria-label="Fermer" disabled={loading}>
                            <X size={18} />
                        </button>
                    </div>

                    <div className="pcModal__body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>

                        {/* Identité Section */}
                        <div className="pcWizStep">
                            <div className="pcWizStep__intro">
                                <div className="pcWizStep__introIcon"><Settings size={20} /></div>
                                <div>
                                    <div className="pcWizStep__introTitle">Informations Générales</div>
                                    <div className="pcWizStep__introSub">Code, catégorie et libellé affiché aux collaborateurs.</div>
                                </div>
                            </div>

                            <div className="pcWizGrid">
                                <div className="pcWizField">
                                    <label>Catégorie (Interne) <span className="pcReq">*</span></label>
                                    <input
                                        type="text"
                                        className={`pcInput ${stepErrors.category ? "is-error" : ""}`}
                                        value={formData.category || ""}
                                        onChange={e => set("category", e.target.value)}
                                        placeholder="Ex: Transport, Repas..."
                                    />
                                    {stepErrors.category && <span className="pcErrMsg">{stepErrors.category}</span>}
                                </div>

                                <div className="pcWizField">
                                    <label>Code <span className="pcReq">*</span> <Tip text="Identifiant court (ex: TRN, RESTO)" /></label>
                                    <input
                                        type="text"
                                        className={`pcInput ${stepErrors.code ? "is-error" : ""}`}
                                        value={formData.code || ""}
                                        onChange={e => set("code", e.target.value.toUpperCase())}
                                        placeholder="TRN"
                                        maxLength={8}
                                    />
                                    {stepErrors.code && <span className="pcErrMsg">{stepErrors.code}</span>}
                                </div>

                                <div className="pcWizField is-full">
                                    <label>Libellé public <span className="pcReq">*</span> <Tip text="Nom affiché dans la sélection pour le collaborateur" /></label>
                                    <input
                                        type="text"
                                        className={`pcInput ${stepErrors.libelle ? "is-error" : ""}`}
                                        value={formData.libelle || ""}
                                        onChange={e => set("libelle", e.target.value)}
                                        placeholder="Ex: Frais de déplacement professionnel"
                                    />
                                    {stepErrors.libelle && <span className="pcErrMsg">{stepErrors.libelle}</span>}
                                </div>

                                {/*<div className="pcWizField">*/}
                                {/*    <label>Centre de CoÃ»ts</label>*/}
                                {/*    <input*/}
                                {/*        type="text"*/}
                                {/*        className="pcInput"*/}
                                {/*        value={formData.centreCouts || ""}*/}
                                {/*        onChange={e => set("centreCouts", e.target.value)}*/}
                                {/*        placeholder="Optionnel"*/}
                                {/*    />*/}
                                {/*</div>*/}

                                <div className="pcWizField">
                                    <label>Statut</label>
                                    <div className="pcToggleRow">
                                        <Toggle
                                            checked={!!formData.actif}
                                            onChange={v => set("actif", v)}
                                            disabled={loading}
                                        />
                                        <span className={`pcToggleStatus ${formData.actif ? "is-on" : ""}`}>
                                            {formData.actif ? "Actif" : "Inactif"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Plafonds Section */}
                        <div className="pcWizStep" style={{ marginTop: '20px' }}>
                            <div className="pcWizStep__intro">
                                <div className="pcWizStep__introIcon"><TrendingUp size={20} /></div>
                                <div>
                                    <div className="pcWizStep__introTitle">Plafonds & Devises</div>
                                    <div className="pcWizStep__introSub">Montants de dépenses autorisés.</div>
                                </div>
                            </div>

                            <div className="pcWizGrid">
                                <div className="pcWizField">
                                    <label>Montant Minimum</label>
                                    <div className="pcNumInput">
                                        <button type="button" onClick={() => set("montantMinimum", Math.max(0, (formData.montantMinimum || 0) - 1))}><Minus size={14} /></button>
                                        <input
                                            type="number"
                                            className="pcInput pcInput--center"
                                            value={formData.montantMinimum || ""}
                                            onChange={e => set("montantMinimum", e.target.value)}
                                            min={0}
                                        />
                                        <button type="button" onClick={() => set("montantMinimum", (Number(formData.montantMinimum) || 0) + 1)}><Plus size={14} /></button>
                                    </div>
                                </div>

                                <div className="pcWizField">
                                    <label>Plafond / Maximum</label>
                                    <div className="pcNumInput">
                                        <button type="button" onClick={() => set("montantMaximum", Math.max(0, (formData.montantMaximum || 0) - 1))}><Minus size={14} /></button>
                                        <input
                                            type="number"
                                            className={`pcInput pcInput--center ${stepErrors.montantMaximum ? "is-error" : ""}`}
                                            value={formData.montantMaximum || ""}
                                            onChange={e => set("montantMaximum", e.target.value)}
                                            min={0}
                                        />
                                        <button type="button" onClick={() => set("montantMaximum", (Number(formData.montantMaximum) || 0) + 1)}><Plus size={14} /></button>
                                    </div>
                                    {stepErrors.montantMaximum && <span className="pcErrMsg">{stepErrors.montantMaximum}</span>}
                                </div>

                                <div className="pcWizField is-full">
                                    <label>Devise <span className="pcReq">*</span></label>
                                    <div className="pcSelectWrap">
                                        <select className="pcInput" value={formData.devise || "MAD"} onChange={e => set("devise", e.target.value)}>
                                            <option value="MAD">MAD - Dirham Marocain</option>
                                            <option value="EUR">EUR - Euro</option>
                                            <option value="USD">USD - Dollar Américain</option>
                                            <option value="GBP">GBP - Livre Sterling</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Justificatifs */}
                        <div className="pcWizStep" style={{ marginTop: '20px' }}>
                            <div className="pcWizStep__intro">
                                <div className="pcWizStep__introIcon"><FileText size={20} /></div>
                                <div>
                                    <div className="pcWizStep__introTitle">Justificatifs</div>
                                    <div className="pcWizStep__introSub">Documents requis pour les demandes.</div>
                                </div>
                            </div>
                            <div className="pcWizGrid">
                                <div className="pcWizField">
                                    <label>Obligation</label>
                                    <div className="pcInfoBox" style={{ height: '100%' }}>
                                        <Toggle checked={!!formData.obligatoire} onChange={v => {
                                            set("obligatoire", v);
                                            // Si on décoche, on n'a plus forcément besoin du type
                                            if (!v && stepErrors.typeJustificatif) {
                                                const newErrs = {...stepErrors};
                                                delete newErrs.typeJustificatif;
                                                setStepErrors(newErrs);
                                            }
                                        }} disabled={loading} />
                                        <div>
                                            <div style={{ fontWeight: 600, fontSize: 12 }}>Justificatif obligatoire</div>
                                            <div style={{ fontSize: 11, color: "#64748b" }}>Empêche la soumission sans fichier.</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="pcWizField">
                                    <label>Type de justificatif {formData.obligatoire && <span className="pcReq">*</span>}</label>
                                    <div className="pcSelectWrap">
                                        <select
                                            className={`pcInput ${stepErrors.typeJustificatif ? "is-error" : ""}`}
                                            value={formData.typeJustificatif || ""}
                                            onChange={e => set("typeJustificatif", e.target.value)}
                                        >
                                            <option value="">{formData.obligatoire ? "Sélectionnez un type" : "Aucun"}</option>
                                            {typeJustificatifOptions.map((option) => (
                                                <option key={option} value={option}>{option}</option>
                                            ))}
                                        </select>
                                    </div>
                                    {stepErrors.typeJustificatif && <span className="pcErrMsg">{stepErrors.typeJustificatif}</span>}
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="pcModal__footer">
                        <button className="pcBtn pcBtn--ghost" type="button" onClick={closeModal} disabled={loading}>
                            Annuler
                        </button>
                        <button className="pcBtn pcBtn--primary" type="button" onClick={handleSubmit} disabled={loading}>
                            {isEdit ? 'Enregistrer les modifications' : 'Créer la note de frais'}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="pcPage">
            <div className="pcHeader">
                <div>
                    <h1>Types de notes de frais</h1>
                    <p>Configurez les catégories de frais, plafonds, devises et documents requis.</p>
                    {error && <div style={{ marginTop: 8, color: '#b91c1c', fontWeight: 700 }}>Erreur: {error}</div>}
                </div>
            </div>

            <div className="pcWrap">
                <div className="pcCard">
                    <div className="pcBody">
                        <div className="pcTopRow">
                            <h2 className="pcTitle">Catégories de frais paramétrables</h2>
                            <button
                                className="pcBtn pcBtn--primary"
                                type="button"
                                onClick={() => openModal()}
                                disabled={loading}
                            >
                                <Plus size={16} /> Ajouter une note de frais
                            </button>
                        </div>

                        <div className="pcTableWrap">
                            <table className="pcTable">
                                <thead>
                                <tr>
                                    <th>Code</th>
                                    <th>Catégorie & Libellé</th>
                                    <th>Montants</th>
                                    <th>Devise</th>
                                    <th>Justificatif</th>
                                    <th>Statut</th>
                                    <th className="is-right">Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={7} className="pcEmptyCell">
                                            Chargement...
                                        </td>
                                    </tr>
                                ) : (notesDeFrais || []).length === 0 ? (
                                    <tr>
                                        <td colSpan={7} className="pcEmptyCell">
                                            Aucune note de frais configurée
                                        </td>
                                    </tr>
                                ) : (
                                    (notesDeFrais || []).map((note) => (
                                        <tr key={note.id}>
                                            <td>
                                                <span className="pcCode" style={{ backgroundColor: '#2f4595' }}>
                                                    {note.code}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="pcStrong">{note.category}</div>
                                                <div className="pcMuted" style={{ fontSize: '11px' }}>{note.libelle || '-'}</div>
                                            </td>
                                            <td>
                                                <div className="pcMuted">Min: {note.montantMinimum ? `${note.montantMinimum.toFixed(2)}` : '-'}</div>
                                                <div className="pcMuted">Max: {note.montantMaximum ? `${note.montantMaximum.toFixed(2)}` : '-'}</div>
                                            </td>
                                            <td>
                                                <span className="pcPill is-primary">{note.devise || 'MAD'}</span>
                                            </td>
                                            <td>
                                                {note.typeJustificatif ? (
                                                    <div className="pcInline">
                                                        <FileText size={14} className="pcAccent" />
                                                        <span style={{ fontSize: '12px', marginLeft: 4 }}>{note.typeJustificatif}</span>
                                                        {note.obligatoire && <CheckCircle size={14} className="pcOk" style={{ marginLeft: 4 }} title="Obligatoire" />}
                                                    </div>
                                                ) : (
                                                    <span className="pcMuted">-</span>
                                                )}
                                            </td>
                                            <td>
                                                <button
                                                    className={`pcPill ${note.actif ? 'is-on' : 'is-off'}`}
                                                    type="button"
                                                    onClick={() => toggleActif(note)}
                                                    disabled={loading}
                                                >
                                                    {note.actif ? 'Actif' : 'Inactif'}
                                                </button>
                                            </td>
                                            <td className="is-right">
                                                <div className="pcRowActions">
                                                    <button
                                                        className="pcIconBtn"
                                                        type="button"
                                                        title="Modifier"
                                                        onClick={() => openModal(note)}
                                                        disabled={loading}
                                                    >
                                                        <Edit size={16} />
                                                    </button>
                                                    <button
                                                        className="pcIconBtn pcIconBtn--danger"
                                                        type="button"
                                                        title="Supprimer"
                                                        onClick={() => handleDelete(note.id)}
                                                        disabled={loading}
                                                    >
                                                        <Trash2 size={16} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {renderModal()}
        </div>
    );
};

export default ParamNF;
